export function parseCsrfTokenFromPage(): string {
  const csrfToken = document.documentElement.getAttribute('data-csrf');

  return csrfToken || '';
}
